<template>
  <div>
    <ul class="inputs_list">
      <li class="inputs_item" v-for="(item, index) in array" :key="index">
        <slot v-bind:index="index" v-bind:item="array[index]"></slot>
        <button class="inputs_item_btn" type="button" v-on:click="removeInput(index)" v-if="index !== 0">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M32 464C32 490.5 53.5 512 80 512h288c26.5 0 48-21.5 48-48V128H32V464zM304 208C304 199.1 311.1 192 320 192s16 7.125 16 16v224c0 8.875-7.125 16-16 16s-16-7.125-16-16V208zM208 208C208 199.1 215.1 192 224 192s16 7.125 16 16v224c0 8.875-7.125 16-16 16s-16-7.125-16-16V208zM112 208C112 199.1 119.1 192 128 192s16 7.125 16 16v224C144 440.9 136.9 448 128 448s-16-7.125-16-16V208zM432 32H320l-11.58-23.16c-2.709-5.42-8.25-8.844-14.31-8.844H153.9c-6.061 0-11.6 3.424-14.31 8.844L128 32H16c-8.836 0-16 7.162-16 16V80c0 8.836 7.164 16 16 16h416c8.838 0 16-7.164 16-16V48C448 39.16 440.8 32 432 32z"/></svg>
        </button>
      </li>
    </ul>

    <button class="inputs_item_btn inputs_item_btn__plus" type="button" v-on:click="addInput()" v-if="array.length < this.limit" v-bind:disabled="disabled">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM352 280H280V352c0 13.2-10.8 24-23.1 24C242.8 376 232 365.2 232 352V280H160C146.8 280 136 269.2 136 256c0-13.2 10.8-24 24-24H232V160c0-13.2 10.8-24 24-24C269.2 136 280 146.8 280 160v72h72C365.2 232 376 242.8 376 256C376 269.2 365.2 280 352 280z"/></svg>
      追加する
    </button>
  </div>
</template>

<script>
  export default {
    props:['initArray', 'initTemplate', 'initDisabled', 'initLimit'],
    data() {
      return{
        array: this.initArray,
        template: this.initTemplate,
        disabled: this.initDisabled,
        limit: this.initLimit,
      }
    },
    methods: {
      // 入力欄追加
      addInput () {
        this.array.push({...this.template});
      },

      // 入力削除
      removeInput (id) {
        let inputList = this.array;
        inputList = inputList.filter((input,index) => {return index !== id;});
        this.array = inputList;
      }
    },
    watch: {
      array: {
      handler: function(newVal, oldVal) {
        this.array.forEach((item, index) => {
          Object.entries(item).forEach(el => {
            if(el[1] != null){
              let temp =   String(el[1]).replace(/[！-～]/g, function(all) {
                                return String.fromCharCode(all.charCodeAt(0) - 0xFEE0);
                              }).replace('　', ' ');
              
              this.array[index][el[0]] = temp;
            }
          });
        });
      },
      deep : true,
      immediate: true

      }
    },
  }
</script>

<style scoped lang="scss">
.inputs{
  &_list{
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  &_item{
    display: flex;
    align-items: center;
    gap: 30px;

    &_btn{
      display: flex;
      align-items: center;
      padding: 9px;
      border-radius: 5px;
      background-color: #F8721E;
      svg{
        width: 17px;
        height: 17px;
        fill: #fff;
      }

      &__plus{
        gap: 10px;
        margin-top: 20px;
        background-color: #0a409a;
        color: #fff;
        font-size: 15px;
        svg{
          width: 13px;
          height: 13px;
        }
        &:disabled{
          background: #666666;
        }
      }
    }
  }
}
</style>